import { motion, useScroll, useSpring } from "framer-motion";

export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });

  return (
    <motion.div
      className="fixed top-0 left-0 right-0 h-1 bg-[var(--nily-teal)] origin-left z-[60] shadow-[0_0_10px_var(--nily-teal)]"
      style={{ scaleX }}
    />
  );
}
